<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()"><span>Ascondb</span></a>
  </div>
  <nb-actions size="medium" style="cursor: pointer">
    <nb-action class="username text-white" (click)="goToClientAccount()">
      <span>Aplicație clienți</span>
    </nb-action>
  </nb-actions>

  <nb-actions size="medium" *ngFor="let bookmark of bookmarks" style="cursor: pointer">
    <nb-action class="username text-white" [routerLink]="bookmark.link" [hidden]="bookmark.hidden">
      <a [routerLink]="bookmark.link" class="text-white bookmark-link">
      <span>{{ bookmark.title }}</span>
    </a>
    </nb-action>
  </nb-actions>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="it-tasks" nbContextMenuTrigger="click"  *ngIf="canAddItTask" (click)="newItTasksModal()" >
      <div #itTaskElement>
        Adaugă Task IT 
      </div>
    </nb-action>
    <nb-action class="conta-tickets" nbContextMenuTrigger="click" (click)="openTicketsModal()" *ngIf="canSeeTickets">
      <div #ticketeElement>
        Tickete conta ({{ ticketsCount }})
      </div>
    </nb-action>
    <nb-action icon="power-outline" (click)="logout()" title="Log out" class="username text-white">Log out</nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-action class="control-item">
        <div class="capitalize username">
          <button nbButton status="basic" (click)="navigateSettings()">
            <nb-icon icon="settings-outline"></nb-icon>
            {{userName}}
          </button>
        </div>
      </nb-action>
      <!--      <nb-user [nbContextMenu]="userMenu"-->
      <!--               [onlyPicture]="userPictureOnly"-->
      <!--               [name]="userName"-->
      <!--               [picture]="user?.picture">-->
      <!--      </nb-user>-->
    </nb-action>
  </nb-actions>
  <!--   <nb-icon *ngIf="innerWidth <= 640" icon="close-outline" (click)="hideHeader($event)"></nb-icon> -->
</div>